import { render, staticRenderFns } from "./compliance-export-communication-log.vue?vue&type=template&id=54d82372&scoped=true&"
import script from "./compliance-export-communication-log.vue?vue&type=script&lang=js&"
export * from "./compliance-export-communication-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d82372",
  null
  
)

export default component.exports